export default function SidebarTopClinic() {
  return (
    <div className="sidebar-top shadow-sm p-2 rounded-1 mb-3 dropend">
      <a
        href="javascript:void(0);"
        className="drop-arrow-none"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        data-bs-offset="0,22"
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <span className="avatar rounded-circle flex-shrink-0 p-2">
              <img src="assets/img/icons/trustcare.svg" alt="img" />
            </span>
            <div className="ms-2">
              <h6 className="fs-14 fw-semibold mb-0">Trustcare Clinic</h6>
              <p className="fs-13 mb-0">Lasvegas</p>
            </div>
          </div>
          <i className="ti ti-arrows-transfer-up"></i>
        </div>
      </a>

      <div className="dropdown-menu dropdown-menu-lg">
        <div className="p-2">
          {[
            ["clinic-01.svg", "CureWell Medical Hub", "Ohio"],
            ["clinic-02.svg", "Trustcare Clinic", "Lasvegas"],
            ["clinic-03.svg", "NovaCare Medical", "Washington"],
            ["clinic-04.svg", "Greeny Medical Clinic", "Illinios"],
          ].map(([icon, name, city]) => (
            <label
              key={name}
              className="dropdown-item d-flex align-items-center justify-content-between p-1"
            >
              <span className="d-flex align-items-center">
                <span className="me-2">
                  <img src={`assets/img/icons/${icon}`} alt="" />
                </span>
                <span className="fw-semibold text-dark">
                  {name}
                  <small className="d-block text-muted fw-normal fs-13">
                    {city}
                  </small>
                </span>
              </span>

              <input className="form-check-input m-0 me-2" type="checkbox" />
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
